import { handleError } from '@offerzen/pinata'
import { notify } from '@offerzen/react-utils'

export const errorHandler = (error, defaultErrorMessage) =>
  handleError({
    errorClientCallback: () => notify(error),
    error,
    defaultErrorMessage,
  })

export const notFoundReactQuery = error => {
  if (!error || !error.response || !error.response.errors) return false
  return error.response.errors.filter(e => e.extensions?.code === 'not_found').length > 0
}
